import {select} from "../../store";
import {ADMISSION_VERIFY_ANSWERS_ROUTE} from "../../pages/page-admission-verify-answers/route";
import {createRouteGuard} from "../../routers/createRouteGuard";

export const UserIsLoggedOut = createRouteGuard({
  authenticatedSelector: state => !select.admissionSession.isLoggedIn(state),
  redirectPath: ADMISSION_VERIFY_ANSWERS_ROUTE,
});
